import { type DgContent, displayMinutes, guideMinutes } from '@sigora/domain';

/** "1 minute", "3 polls": a count with the noun that agrees with it. */
export const plural = (count: number, one: string, many: string): string =>
  `${String(count)} ${count === 1 ? one : many}`;

/** "about 4 minutes each": the guide's own minutes per person, as the Guide and Launch say them. */
export const guideMinutesLabel = (content: DgContent): string =>
  `about ${plural(displayMinutes(guideMinutes(content)), 'minute', 'minutes')} each`;
